import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  class: "title-count"
};
var _hoisted_2 = {
  class: "title-count"
};
var _hoisted_3 = {
  class: "title-count"
};
var _hoisted_4 = {
  key: 1,
  class: "out-of-stock-titles"
};
var _hoisted_5 = ["src"];
import { ref, watch, reactive, onMounted } from 'vue';
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
import cartUtils from '../cartUtils';
import CartItem from './CartItem.vue';
import { useRouter } from 'vue-router';
import CartEmpty from './CartEmpty.vue';
import { useLess } from '@/models/hooks';
import imageLink from '@/configs/imageLink';
import { getAppConfig } from '@/utils/common';
import { cartTabsUtilsFun } from './CartTabsUtils';
import { clickEvents } from '@/configs/awsRumConfig';
import { getPromotionList } from '@/utils/newUserCoupon';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import ShareApp from '@/components/shareApp/ShareApp.vue';
import CartItemsRemovedFromShelves from './CartItemsRemovedFromShelves.vue';
import BuyingOptionsPopup from '@/components/buyingOptionsPopup/BuyingOptionsPopup.vue';
export default {
  __name: 'CartTabs',
  props: {
    cptPopupHeight: {
      type: Number,
      require: true,
      default: () => 0
    }
  },
  setup(__props) {
    useLess('views/cart/components/CartTabs.less');
    var APP_CONFIG_TYPES = constants.Common.APP_CONFIG_TYPES;
    var SELECTED = imageLink.SELECTED,
      NOT_SELECTED = imageLink.NOT_SELECTED,
      SUCCESS_ICON_IMAGE_URL = imageLink.SUCCESS_ICON_IMAGE_URL;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var router = useRouter();
    var cartTabsRef = reactive([]);
    var asinStocksReminder = ref(null);
    var couponList = ref([]);

    // Shopping cart data processing function
    var _cartUtils$cartState = cartUtils.cartState,
      cartData = _cartUtils$cartState.cartData,
      isLoading = _cartUtils$cartState.isLoading,
      activeTab = _cartUtils$cartState.activeTab,
      ACTIVE_NAME = _cartUtils$cartState.ACTIVE_NAME,
      isManagement = _cartUtils$cartState.isManagement,
      allProductData = _cartUtils$cartState.allProductData,
      outOfStockData = _cartUtils$cartState.outOfStockData,
      reducePriceData = _cartUtils$cartState.reducePriceData,
      CART_TABS_INDEX = _cartUtils$cartState.CART_TABS_INDEX,
      isHiddenBottomArea = _cartUtils$cartState.isHiddenBottomArea,
      alreadySoldOutData = _cartUtils$cartState.alreadySoldOutData,
      selectAllOutOfStock = _cartUtils$cartState.selectAllOutOfStock,
      dotdOrSpecialSaleProductData = _cartUtils$cartState.dotdOrSpecialSaleProductData;
    var _cartUtils$handleCart = cartUtils.handleCartState,
      getAndUpdateData = _cartUtils$handleCart.getAndUpdateData,
      onUpdateItemCount = _cartUtils$handleCart.onUpdateItemCount,
      onUpdateItemCheck = _cartUtils$handleCart.onUpdateItemCheck,
      onClickAllOutOfStock = _cartUtils$handleCart.onClickAllOutOfStock;
    var _cartTabsUtilsFun$car = cartTabsUtilsFun(cartData, isLoading).cartTabsState,
      isShowShareApp = _cartTabsUtilsFun$car.isShowShareApp,
      shareConfiguration = _cartTabsUtilsFun$car.shareConfiguration,
      selectProductParams = _cartTabsUtilsFun$car.selectProductParams;
    var _cartTabsUtilsFun$han = cartTabsUtilsFun(cartData, isLoading).handleCartTabsState,
      onShareItem = _cartTabsUtilsFun$han.onShareItem,
      onDeleteItem = _cartTabsUtilsFun$han.onDeleteItem,
      onSelectProduct = _cartTabsUtilsFun$han.onSelectProduct,
      onAddToFavorite = _cartTabsUtilsFun$han.onAddToFavorite,
      onRemoveFavorite = _cartTabsUtilsFun$han.onRemoveFavorite,
      onCountDownFinish = _cartTabsUtilsFun$han.onCountDownFinish;

    // Select the product callback data={count, asin, price}
    var onProductOnConfirm = () => {
      showToast({
        message: t('common.SUCCESS_ADDED_CART'),
        icon: SUCCESS_ICON_IMAGE_URL,
        overlay: false,
        overlayClass: 'a-overlay-white',
        className: 'a-toast'
      });
      getAndUpdateData();
    };

    // Jump details
    var onToDetail = asinId => {
      awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.cartPage.goToProductDetail_btn), {}, {
        asinid: asinId
      }));
      isHiddenBottomArea.value = true;
      router.push({
        name: 'detailPage',
        params: {
          asinId
        }
      });
    };

    // Track tabs click data
    watch(activeTab, value => {
      switch (value) {
        case ACTIVE_NAME.DOTD:
          awsRumHandler.recordClickEvent(clickEvents.cartPage.filterDOTD_btn);
          break;
        case ACTIVE_NAME.REDUCE_THE_PRICE:
          awsRumHandler.recordClickEvent(clickEvents.cartPage.filterPriceDrop_btn);
          break;
        case ACTIVE_NAME.ALREADY_SOLD_OUT:
          awsRumHandler.recordClickEvent(clickEvents.cartPage.filterOutOfStock_btn);
          break;
        default:
          break;
      }
    });
    var getAsinStocksReminder = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var configData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAppConfig(APP_CONFIG_TYPES.SETTING_PAGE);
            case 2:
              configData = _context.sent;
              asinStocksReminder.value = configData.asinStocksReminder;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getAsinStocksReminder() {
        return _ref.apply(this, arguments);
      };
    }();
    onMounted(() => {
      cartTabsRef.forEach(item => {
        item.style.width = `${item.offsetWidth}px`;
        item.style.whiteSpace = 'nowrap';
      });
      getAsinStocksReminder();
      // Get a list of discount coupons
      getPromotionList(data => {
        couponList.value = data || [];
      });
    });
    return (_ctx, _cache) => {
      var _component_van_tab = _resolveComponent("van-tab");
      var _component_van_checkbox = _resolveComponent("van-checkbox");
      var _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_tabs, {
        class: "cart-tab-select",
        active: _unref(activeTab),
        "onUpdate:active": _cache[1] || (_cache[1] = $event => _isRef(activeTab) ? activeTab.value = $event : null),
        "lazy-render": false
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          name: _unref(ACTIVE_NAME).ALL
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            ref: el => cartTabsRef[_unref(CART_TABS_INDEX).ALL] = el
          }, _toDisplayString(_ctx.$t('modules.cart.ALL')), 513)]),
          default: _withCtx(() => [!_unref(allProductData).length ? (_openBlock(), _createBlock(CartEmpty, {
            key: 0,
            emptyTextPartOne: _ctx.$t('modules.cart.SHOPPING_CART_IS_EMPTY'),
            emptyTextPartTwo: _ctx.$t('modules.cart.ADD_YOUR_FAVOURITE_ITEM_IN_IT'),
            showButton: true
          }, null, 8, ["emptyTextPartOne", "emptyTextPartTwo"])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(_unref(allProductData), item => {
            return _openBlock(), _createBlock(CartItem, {
              class: "cart-product-item",
              key: item.asin,
              item: item,
              couponList: couponList.value,
              isManagement: _unref(isManagement),
              asinStocksReminder: asinStocksReminder.value,
              onOnToDetail: onToDetail,
              onOnDeleteItem: _unref(onDeleteItem),
              onUpdateCount: _unref(onUpdateItemCount),
              onUpdateCheck: _unref(onUpdateItemCheck),
              onOnSelectProduct: _unref(onSelectProduct),
              onOnShareItem: _unref(onShareItem),
              onOnAddToFavorite: _unref(onAddToFavorite),
              onOnRemoveFavorite: _unref(onRemoveFavorite),
              onOnCountDownFinish: _unref(onCountDownFinish)
            }, null, 8, ["item", "couponList", "isManagement", "asinStocksReminder", "onOnDeleteItem", "onUpdateCount", "onUpdateCheck", "onOnSelectProduct", "onOnShareItem", "onOnAddToFavorite", "onOnRemoveFavorite", "onOnCountDownFinish"]);
          }), 128))]),
          _: 1
        }, 8, ["name"]), _createVNode(_component_van_tab, {
          title: `${_ctx.$t('modules.cart.DOTD_OR_SPECIAL_SALE_EVENT') + ' ' + _unref(dotdOrSpecialSaleProductData).length}`,
          name: _unref(ACTIVE_NAME).DOTD
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            ref: el => cartTabsRef[_unref(CART_TABS_INDEX).DOTD_OR_SPECIAL_SALE_EVENT] = el
          }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.DOTD_OR_SPECIAL_SALE_EVENT')) + " ", 1), _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(dotdOrSpecialSaleProductData).length), 1)], 512)]),
          default: _withCtx(() => [!_unref(dotdOrSpecialSaleProductData).length ? (_openBlock(), _createBlock(CartEmpty, {
            key: 0,
            emptyText: _ctx.$t('modules.cart.CART_NO_DOTD_OR_SPECIAL_SALE_EVENT_ITEM')
          }, null, 8, ["emptyText"])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(_unref(dotdOrSpecialSaleProductData), item => {
            return _openBlock(), _createBlock(CartItem, {
              class: "cart-product-item",
              key: item.asin,
              item: item,
              couponList: couponList.value,
              isManagement: _unref(isManagement),
              asinStocksReminder: asinStocksReminder.value,
              onOnToDetail: onToDetail,
              onOnDeleteItem: _unref(onDeleteItem),
              onUpdateCount: _unref(onUpdateItemCount),
              onUpdateCheck: _unref(onUpdateItemCheck),
              onOnSelectProduct: _unref(onSelectProduct),
              onOnShareItem: _unref(onShareItem),
              onOnAddToFavorite: _unref(onAddToFavorite),
              onOnRemoveFavorite: _unref(onRemoveFavorite),
              onOnCountDownFinish: _unref(onCountDownFinish)
            }, null, 8, ["item", "couponList", "isManagement", "asinStocksReminder", "onOnDeleteItem", "onUpdateCount", "onUpdateCheck", "onOnSelectProduct", "onOnShareItem", "onOnAddToFavorite", "onOnRemoveFavorite", "onOnCountDownFinish"]);
          }), 128))]),
          _: 1
        }, 8, ["title", "name"]), _createVNode(_component_van_tab, {
          name: _unref(ACTIVE_NAME).REDUCE_THE_PRICE
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            ref: el => cartTabsRef[_unref(CART_TABS_INDEX).REDUCE_THE_PRICE] = el
          }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.REDUCE_THE_PRICE')) + " ", 1), _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(reducePriceData).length), 1)], 512)]),
          default: _withCtx(() => [!_unref(reducePriceData).length ? (_openBlock(), _createBlock(CartEmpty, {
            key: 0,
            emptyText: _ctx.$t('modules.cart.CART_NO_REDUCETHEPRICE_ITEM')
          }, null, 8, ["emptyText"])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(_unref(reducePriceData), item => {
            return _openBlock(), _createBlock(CartItem, {
              class: "cart-product-item",
              key: item.asin,
              item: item,
              couponList: couponList.value,
              asinStocksReminder: asinStocksReminder.value,
              onOnToDetail: onToDetail,
              onOnDeleteItem: _unref(onDeleteItem),
              onUpdateCount: _unref(onUpdateItemCount),
              onUpdateCheck: _unref(onUpdateItemCheck),
              onOnSelectProduct: _unref(onSelectProduct),
              onOnShareItem: _unref(onShareItem),
              onOnAddToFavorite: _unref(onAddToFavorite),
              onOnRemoveFavorite: _unref(onRemoveFavorite),
              onOnCountDownFinish: _unref(onCountDownFinish)
            }, null, 8, ["item", "couponList", "asinStocksReminder", "onOnDeleteItem", "onUpdateCount", "onUpdateCheck", "onOnSelectProduct", "onOnShareItem", "onOnAddToFavorite", "onOnRemoveFavorite", "onOnCountDownFinish"]);
          }), 128))]),
          _: 1
        }, 8, ["name"]), _createVNode(_component_van_tab, {
          title: _ctx.$t('modules.cart.ALREADY_SOLD_OUT') + ' ' + (_unref(alreadySoldOutData).length + _unref(outOfStockData).length),
          name: _unref(ACTIVE_NAME).ALREADY_SOLD_OUT
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            ref: el => cartTabsRef[_unref(CART_TABS_INDEX).ALREADY_SOLD_OUT] = el
          }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.ALREADY_SOLD_OUT')) + " ", 1), _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(alreadySoldOutData).length + _unref(outOfStockData).length), 1)], 512)]),
          default: _withCtx(() => [!_unref(alreadySoldOutData).length && !_unref(outOfStockData).length ? (_openBlock(), _createBlock(CartEmpty, {
            key: 0,
            emptyText: _ctx.$t('modules.cart.CART_NO_ALREADYSOLDOUT_ITEM')
          }, null, 8, ["emptyText"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_unref(alreadySoldOutData).length ? (_openBlock(), _createBlock(CartItemsRemovedFromShelves, {
            key: 0,
            removedData: _unref(alreadySoldOutData),
            onUpdateCheck: _unref(onUpdateItemCheck)
          }, null, 8, ["removedData", "onUpdateCheck"])) : _createCommentVNode("", true), _unref(outOfStockData).length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_checkbox, {
            class: "radio",
            modelValue: _unref(selectAllOutOfStock),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(selectAllOutOfStock) ? selectAllOutOfStock.value = $event : null),
            "checked-color": "#eb1745",
            onClick: _unref(onClickAllOutOfStock)
          }, {
            icon: _withCtx(checkboxProps => [_createElementVNode("img", {
              src: checkboxProps.checked ? _unref(SELECTED) : _unref(NOT_SELECTED)
            }, null, 8, _hoisted_5)]),
            _: 1
          }, 8, ["modelValue", "onClick"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('modules.cart.OUT_OF_STOCK_AT_PRESENT')), 1)])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(outOfStockData), item => {
            return _openBlock(), _createBlock(CartItem, {
              class: "cart-product-item",
              key: item.asin,
              item: item,
              isManagement: true,
              onOnToDetail: onToDetail,
              onOnDeleteItem: _unref(onDeleteItem),
              onUpdateCount: _unref(onUpdateItemCount),
              onUpdateCheck: _unref(onUpdateItemCheck),
              onOnAddToFavorite: _unref(onAddToFavorite),
              onOnRemoveFavorite: _unref(onRemoveFavorite),
              onOnShareItem: _unref(onShareItem)
            }, null, 8, ["item", "onOnDeleteItem", "onUpdateCount", "onUpdateCheck", "onOnAddToFavorite", "onOnRemoveFavorite", "onOnShareItem"]);
          }), 128))], 64))]),
          _: 1
        }, 8, ["title", "name"])]),
        _: 1
      }, 8, ["active"]), _unref(isShowShareApp) ? (_openBlock(), _createBlock(ShareApp, {
        key: 0,
        style: _normalizeStyle({
          marginBottom: __props.cptPopupHeight + 'px'
        }),
        show: _unref(isShowShareApp),
        "onUpdate:show": _cache[2] || (_cache[2] = $event => _isRef(isShowShareApp) ? isShowShareApp.value = $event : null),
        shareConfiguration: _unref(shareConfiguration)
      }, null, 8, ["style", "show", "shareConfiguration"])) : _createCommentVNode("", true), _unref(selectProductParams).showAddCart ? (_openBlock(), _createBlock(BuyingOptionsPopup, {
        key: 1,
        marginBottom: __props.cptPopupHeight,
        isAddToCart: true,
        quantity: _unref(selectProductParams).selectedCount,
        "onUpdate:quantity": _cache[3] || (_cache[3] = $event => _unref(selectProductParams).selectedCount = $event),
        isShowPopup: _unref(selectProductParams).showAddCart,
        "onUpdate:isShowPopup": _cache[4] || (_cache[4] = $event => _unref(selectProductParams).showAddCart = $event),
        promotionInfoList: couponList.value,
        selectedAsin: _unref(selectProductParams).selectedAsin,
        merchantId: _unref(selectProductParams).selectedMerchantId,
        isProductReplace: _unref(selectProductParams).isProductReplace,
        onOnConfirm: onProductOnConfirm
      }, null, 8, ["marginBottom", "quantity", "isShowPopup", "promotionInfoList", "selectedAsin", "merchantId", "isProductReplace"])) : _createCommentVNode("", true)], 64);
    };
  }
};